import React from 'react';
import Template from './template';
import { PartnerCreated } from 'components';

function PartnerCreatedView(): React.ReactElement {
    return (
        <Template>
            <PartnerCreated />
        </Template>
    );
}

export default PartnerCreatedView;
